module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "remove-warning"
    }
  }, [_c('div', {
    staticClass: "modal is-active"
  }, [_c('div', {
    staticClass: "modal-background"
  }), _c('div', {
    staticClass: "modal-content"
  }, [_c('article', {
    staticClass: "message is-danger"
  }, [_c('div', {
    staticClass: "message-header"
  }, [_c('p', [_vm._v(_vm._s(_vm.tokens['header'](_vm.object)) + ".")]), _c('button', {
    staticClass: "delete",
    on: {
      "click": _vm.reject
    }
  })]), _c('div', {
    staticClass: "message-body"
  }, [_c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('span', [_c('span', [_vm._v(_vm._s(_vm.tokens['warning'](_vm.object, _vm.name)) + ". ")]), _vm._t("default"), _c('span', [_vm._v(_vm._s(_vm.tokens['continue']))])], 2)])]), _c('div', {
    staticClass: "level"
  }, [_c('div', {
    staticClass: "level-item"
  }, [_c('button', {
    staticClass: "button is-danger",
    on: {
      "click": _vm.confirm
    }
  }, [_vm._v(_vm._s(_vm.tokens['ok']))]), _c('button', {
    staticClass: "button",
    on: {
      "click": _vm.reject
    }
  }, [_vm._v(_vm._s(_vm.tokens['cancel']))])])])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fc7e7726"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/widgets/RemoveWarning.vue
// module id = 451
// module chunks = 0